module.exports = __webpack_public_path__ + "img/agent-money_bag.f19b4615.svg";